import React, { useEffect, useState } from 'react';
import { connect, Provider } from "react-redux";
import {
    setAppCustomTitle
} from "../reducers/ThemeOptions";
import requestApi from '../services/requestApi.service';
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { Row, Col } from 'reactstrap';

import { getSessionValue, handelCommonChangeAgent, handleCommonRemoveAgent, renderSelectableList } from './Appcommon';

const IOMapping = (props) => {
    const { handleOnChange, defaultId ,type} = props;
    const { handleSubmit, control, reset, formState: { errors }, trigger } = useForm({});

    //These hold the currently available Option
    const [options, setOptions] = useState([]);

    // These hold the selected agents for each type
    const [selects, setSelects] = useState([{ value: null }]);

    // These hold the currently available after Select
    const [sync, setSync] = useState([]);

    const proName = getSessionValue("agent_provider_name");

    // Fetch options on mount
    const getSelectOption = async () => {
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "FETCH_IO_SELECT_OPTIONS",
            provider:proName,
            type:type,
            defaultId:defaultId,
        };
        try {
            let response = await requestApi.processServerRequest(params);
            if (response.issuccess) {
                setOptions(response.data?.[0] ?? []);
                let resData = response.data[1] ?? [];
                updateSelects(resData, setSelects, type);
            } else {
                console.error("Fetch failed", response);
            }
        } catch (error) {
            console.error("Error Unable to get Details:", error);
        }
    };

    const updateSelects = (data, setFunc, type) => {
        const list = data?.length ? data.map(item => ({ value: item })) : [{ value: null }];
        setFunc(list);
        handleOnChange(type, data?.length ? data : []);
    };

    useEffect(() => {
        getSelectOption();
    }, [defaultId]);

    const handleOnChangeSendData = (type,selectedOption) =>{
        handleOnChange?.(type,selectedOption);
    }

    // Use the existing async handler function for select change
    const handleSelectChange = async (type, index, selected,) =>{
        const [updatedList, updatedSyncOption, updatedCurrentOption] = await handelCommonChangeAgent(selected,index,selects, options,sync);
        setSelects(updatedList);
        setSync(updatedSyncOption);
        setOptions(updatedCurrentOption);
        handleOnChangeSendData(type,updatedSyncOption);
    };

    const removeSelect = async (type, index) => {
        const [updatedList, updatedSyncOption, updatedCurrentOption] = await handleCommonRemoveAgent(index,selects,options);
        setSelects(updatedList);
        setSync(updatedSyncOption);
        setOptions(updatedCurrentOption);
        handleOnChangeSendData(type,updatedSyncOption);
    };


    // Add new empty select field
    const addMore = () => {
        setSelects(prev => [...prev, { value: null }]);
    };

    return (
        <>
            <Row>
                {renderSelectableList(selects, options, (selectedOption, idx) => handleSelectChange(type, idx, selectedOption), (idx) => removeSelect(type, idx), (count) => addMore(type), type, 10)}
            </Row>
        </>
    );

};

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IOMapping);
